module.exports = __webpack_public_path__ + "4c51aaf305a05ab3b042807ac1cadf83.png";